import styled from "styled-components";
import * as h from "../_themes/helpers";
import { Title } from "../Title";

export const SettingsWindowTitle = styled(Title)`
  color: ${h.getColor("settingsWindowTitle", "settingsWindow.title")};
  text-align: center;
  font-weight: 700;
  font-size: 1.3em;
  letter-spacing: 0.03em;
  margin-bottom: 0.4em;
  white-space: normal;
  word-break: break-word;
`;
